import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_QR_CODE_LINK_HAS_BLACKLIST_ERROR = 'UPDATE_QR_CODE_LINK_HAS_BLACKLIST_ERROR' as const;

export const updateQrCodeLinkHasBlacklistError = (hasBlacklistError: boolean) => ({
  data: { hasBlacklistError },
  type: UPDATE_QR_CODE_LINK_HAS_BLACKLIST_ERROR,
});

export type UpdateQrCodeLinkHasBlacklistErrorResponseAction = DataAction<
  typeof UPDATE_QR_CODE_LINK_HAS_BLACKLIST_ERROR,
  { hasBlacklistError: boolean }
>;
